import { useEffect, useLayoutEffect } from 'react';
import { EVENTS } from '@trip-ux/constants';
import { useActions, setPageTitle, ReduxStore, setUser } from '@trip-ux/redux-store';
import { useSelector } from 'react-redux';
import { get } from 'lodash';

export const useOnClickOutside = (ref, handler) => {
  useEffect(() => {
    const listener = event => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(event);
    };
    document.addEventListener(EVENTS.MOUSE_DOWN, listener);
    document.addEventListener(EVENTS.TOUCH_START, listener);
    return () => {
      document.removeEventListener(EVENTS.MOUSE_DOWN, listener);
      document.removeEventListener(EVENTS.TOUCH_START, listener);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export const useLayoutReset = (deps = [], className?: string) => {
  useLayoutEffect(() => {
    document.getElementsByClassName(className)[0]?.scrollTo(0, 0);
    window.scrollTo(0, 0);
    //focus to the top of the page
    document.getElementById('header-navigation')?.focus();
  }, deps);
};

export const usePageTitle = (title: string): void => {
  const { pageTitle, userProfile, cfm } = useSelector((store: ReduxStore) => ({
    pageTitle: get(store, 'config.pageTitle'),
    userProfile: get(store, 'userProfile'),
    cfm: get(store, 'contentFragment')
  }));
  const actions = useActions({ setPageTitle });
  const userActions = useActions({ setUser });
  const userOrgObj = {"organizationNameEN": cfm.organizationName, "organizationNameFR": cfm.organizationNameInFrench};
  const userProfileObj = {...userProfile, ...userOrgObj};
  
  useLayoutEffect(() => {
    if (pageTitle !== title) {
      document.title = title;
      actions.setPageTitle(title);
    }
      userActions.setUser(userProfileObj);
  }, [actions, title]);
};

export const useMutationObserver = (
  id,
  callback,
  options = {
    attributes: true,
    childList: true,
    subtree: true
  }
): void => {
  useEffect(() => {
    const targetNode = document.getElementById(id);
    const observer = new MutationObserver(callback);
    if (targetNode) {
      observer.observe(targetNode, options);
    }
    return () => observer.disconnect();
  }, [callback, options]);
};
